import React, { useState } from 'react'
import { useForm } from 'antd/lib/form/Form'
import { useTranslation } from 'react-i18next'
import { Button, Form, message, Modal, Select, Spin } from 'antd'
import dayjs from 'dayjs'

interface IProps {
	getReport: (payload: { languageEnum: string }) => Promise<Blob>
	show: boolean
	onHide: () => void
}

const ReportKurultaiModal = (props: IProps) => {
	const [form] = useForm()
	const { t } = useTranslation()
	const [loading, setLoading] = useState<boolean>(false)
	const [selectedLanguage, setSelectedLanguage] = useState<string>('')

	const languages = [
		{ key: 'ky', label: 'Кыргызский' },
		{ key: 'ru', label: 'Русский' },
	]

	const handleSubmit = async () => {
		setLoading(true)

		try {
			await form.validateFields()
			const payload = { languageEnum: selectedLanguage }
			const blob = await props.getReport(payload)

			const url = window.URL.createObjectURL(blob)
			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', `Kurultai_Report_${dayjs().format('YYYY-MM-DD')}.xlsx`)
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)

			message.success(t('reports.download_success'))
		} catch (error: any) {
			Modal.error({
				title: t('msg.error'),
				content: error.message || t('reports.download_failed'),
			})
		} finally {
			setLoading(false)
		}
	}

	return (
		<Modal
			title={t('reports.report_by_kurultai')}
			open={props.show}
			onCancel={props.onHide}
			onOk={handleSubmit}
			okText={t('general.create')}
			width={500}
			footer={null}
		>
			<Spin spinning={loading} tip={t('reports.loading')}>
				<Form form={form} layout='vertical' autoComplete='off'>
					<Form.Item
						label={t('reports.select_language')}
						name='select_language'
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<Select
							value={selectedLanguage}
							onChange={setSelectedLanguage}
							style={{ width: '100%' }}
							placeholder={t('reports.select_language')}
						>
							{languages.map(lang => (
								<Select.Option key={lang.key} value={lang.key}>
									{lang.label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					<div style={{ textAlign: 'right', marginTop: '20px' }}>
						<Button type='primary' block onClick={handleSubmit}>
							{t('reports.download_report')}
						</Button>
					</div>
				</Form>
			</Spin>
		</Modal>
	)
}

export default ReportKurultaiModal
